import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import CacheBuster from '../contexts/CacheBuster';
import Navbar from './navigation/Navbar';
import { Spinner } from '@happy-doc/shared-components';

const ProtectedRoute: React.FC = () => {
    const { session, isLoading } = useAuth();

    if (isLoading) {
        return <div className="flex justify-center items-center h-screen">
            <Spinner size="small" />
        </div>
    }

    if (!session) {
        return <Navigate to="/login" replace />;
    }

    return (
        <CacheBuster>
            <div className="sticky left-0 right-0 top-0 z-50 navbar-selector">
                {/* Top Nav Bar */}
                <Navbar />
            </div>
            <Outlet />
        </CacheBuster>
    );
};

export default ProtectedRoute;